import { courseProgressConsts } from "../constants/courseProgressConsts"
import { workbooksConstants } from "../constants/workbooksConstants"

const initialState = {
  fetchingGroupCourseProgress: false,
  initializingGCP: false,
  updatingGCP: false,
  groupCourseProgressError: null,
  toggleGroupLessonStatus: false,
  toggleAllGroupLessonStatus: false,
  groupLessonStatusErr: null,
  toggleGroupLessonComplete: false,
  groupLessonCompleteErr: null,
  groupCPs: {}
}

export function groupCourseProgress(state = initialState, action) {
  switch (action.type) {
    case courseProgressConsts.GET_GROUP_COURSE_PROGRESS:
      return {
        ...state,
        fetchingGroupCourseProgress: true
      }
    case courseProgressConsts.GET_GROUP_COURSE_PROGRESS_SUCCESS:
      return {
        ...state,
        groupCPs: {
          ...state.groupCPs,
          ...action.data
        },
        fetchingGroupCourseProgress: false
      }
    case courseProgressConsts.GET_GROUP_COURSE_PROGRESS_FAILURE:
      return {
        ...state,
        fetchingGroupCourseProgress: false,
        groupCourseProgressError: action.error
      }
    case courseProgressConsts.INIT_GROUP_COURSE_PROGRESS:
      return {
        ...state,
        initializingGCP: true
      }
    case courseProgressConsts.INIT_GROUP_COURSE_PROGRESS_SUCCESS:
      return {
        ...state,
        initializingGCP: false,
        fetchingGroupCourseProgress: false
      }
    case courseProgressConsts.INIT_GROUP_COURSE_PROGRESS_FAILURE:
      return {
        ...state,
        initializingGCP: false,
        groupCourseProgressError: action.error,
        fetchingGroupCourseProgress: false
      }
    case courseProgressConsts.UPDATE_GROUP_COURSE_PROGRESS:
      return {
        ...state,
        updatingGCP: true
      }
    case courseProgressConsts.UPDATE_GROUP_COURSE_PROGRESS_SUCCESS:
      return {
        ...state,
        groupCPs: {
          ...state.groupCPs,
          ...action.data
        },
        updatingGCP: false
      }
    case courseProgressConsts.UPDATE_GROUP_COURSE_PROGRESS_FAILURE:
      return {
        ...state,
        updatingGCP: false,
        groupCourseProgressError: action.error
      }

    case workbooksConstants.TOGGLE_GROUP_LESSON_STATUS:
      return {
        ...state,
        toggleGroupLessonStatus: action.lessonId
      }
    case workbooksConstants.TOGGLE_GROUP_LESSON_STATUS_SUCCESS:
      return {
        ...state,
        toggleGroupLessonStatus: false,
        groupCPs: {
          ...state.groupCPs,
          [`${action.id}`]: {
            ...state.groupCPs[`${action.id}`],
            byLesson: {
              ...state.groupCPs[`${action.id}`].byLesson,
              [action.lesson.id]: action.lesson
            }
          }
        }
      }
    case workbooksConstants.TOGGLE_GROUP_LESSON_STATUS_FAILURE:
      return {
        ...state,
        toggleGroupLessonStatus: false,
        groupLessonStatusErr: action.payload
      }

    case workbooksConstants.TOGGLE_ALL_GROUP_LESSON_STATUS:
      return {
        ...state,
        toggleAllGroupLessonStatus: true
      }
    case workbooksConstants.TOGGLE_ALL_GROUP_LESSON_STATUS_SUCCESS:
      return {
        ...state,
        toggleAllGroupLessonStatus: false,
        groupCPs: {
          ...state.groupCPs,
          [`${action.id}`]: {
            ...state.groupCPs[`${action.id}`],
            byLesson: {
              ...state.groupCPs[`${action.id}`].byLesson,
              ...action.lessonGroups
            }
          }
        }
      }
    case workbooksConstants.TOGGLE_ALL_GROUP_LESSON_STATUS_FAILURE:
      return {
        ...state,
        toggleAllGroupLessonStatus: false,
        allGroupLessonStatusErr: action.payload
      }

    case workbooksConstants.TOGGLE_GROUP_LESSON_COMPLETE:
      return {
        ...state,
        toggleGroupLessonComplete: action.lessonId
      }
    case workbooksConstants.TOGGLE_GROUP_LESSON_COMPLETE_SUCCESS:
      return {
        ...state,
        groupCPs: {
          ...state.groupCPs,
          [action.id]: {
            ...state.groupCPs[action.id],
            byLesson: {
              ...state.groupCPs[action.id]?.byLesson,
              [action.lesson.id]: action.lesson
            }
          }
        },
        toggleGroupLessonComplete: false
      }

    case workbooksConstants.TOGGLE_GROUP_LESSON_COMPLETE_FAILURE:
      return {
        ...state,
        toggleGroupLessonComplete: false,
        groupLessonCompleteErr: action.payload
      }

    case workbooksConstants.REFRESH_GCP:
      return {
        ...state,
        fetchingGroupCourseProgress: true
      }
    case "MULTIPLE_YEAR_GCPs":
      return {
        ...state,
        fetchingGroupCourseProgress: false,
        groupCPs: {
          ...state.groupCPs,
          ...action.groupCPs
        }
      }
    default:
      return state
  }
}
